import { gql } from 'graphql-tag'

export default gql`
  fragment EventLocationFragment on EventLocation {
    contentType: __typename
    sys {
      id
    }
    venue
    city
    addressLine1
    addressLine2
    addressLine3
    addressLine4
  }
`
